import { fg } from '@atlaskit/platform-feature-flags/fg';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';

/**
 * Eligibility for Jira Reverse Trial Plan Selection Modal.
 * Shown to billing admins in Jira reverse trial (in trial or predunning).
 */
export function isEligibleForReverseTrialPlanSelection(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInPredunning,
		isInReverseTrial,
		userRoles,
		isInCollection,
		invoiceableStatus,
		canAddPaymentDetails,
		canUpgrade,
	} = context;

	return Boolean(
		isInCollection === 'NOT_IN_COLLECTION' &&
		product === 'jira' &&
		(isInTrial || isInPredunning) &&
		isInReverseTrial &&
		userRoles?.includes('BILLING_ADMIN') &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		canAddPaymentDetails &&
		canUpgrade &&
		isEditionOneOf(
			edition,
			fg('reverse_trial_on_standard_ea_kill_switch') ? ['premium', 'standard'] : ['premium'],
		),
	);
}
